var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4915 35.0774L40.2343 36.0732L40.2841 35.9737C42.7239 32.5878 44.0185 28.5546 44.0185 24.3222C44.0683 18.8948 42.0268 13.816 38.2426 10.0317C34.4583 6.19772 29.4293 4.05664 24.0517 4.05664C12.948 4.05664 3.88574 13.1189 3.88574 24.2226C3.88574 35.3263 12.8982 44.3388 24.0019 44.3388C25.9438 44.3388 27.7862 44.0898 29.5289 43.5421L29.6285 43.4923L29.2301 41.5006L29.0808 41.5504C27.3878 42.0483 25.6451 42.3471 23.9023 42.3471C13.9438 42.3471 5.82765 34.2309 5.82765 24.2724C5.82765 14.3139 13.9438 6.19772 23.9023 6.19772C33.8608 6.19772 41.977 14.3139 41.977 24.2724C41.977 28.1064 40.782 31.7911 38.4915 34.9778V35.0774Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.029 7.44456C36.4979 2.86365 30.4232 0.374023 24.0498 0.374023C21.8091 0.374023 19.6681 0.672779 17.6266 1.27029L17.527 1.32008L17.8755 3.16241L18.0249 3.11261C20.0166 2.56489 22.0581 2.26614 24.0498 2.26614C36.249 2.26614 46.2075 12.1749 46.2075 24.4238C46.2075 36.6728 36.249 46.5317 24.0498 46.5317C11.8008 46.4819 1.89212 36.5234 1.89212 24.3242C1.89212 19.6935 3.28631 15.3118 5.9751 11.5276L6.07469 11.428L4.43154 10.4819L4.38174 10.5815C1.49378 14.6147 0 19.3948 0 24.4238C0 37.6188 10.7552 48.374 23.9502 48.374C37.195 48.374 48 37.6188 48 24.4238C48 18.0006 45.5602 11.9757 41.029 7.44456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0287 22.033L14.4395 24.6222L21.5598 31.7426L33.51 19.7923L30.9208 17.2031L21.5598 26.5641L17.0287 22.033Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImg3);
export default __webpack_public_path__ + "static/media/cardImg3.92f3cf4825cec95ce7627570022ffa9f.svg";
export { ForwardRef as ReactComponent };